import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';
import {RFValue} from 'react-native-responsive-fontsize';
import {Platform} from 'react-native';
import {getBottomSpace} from 'react-native-iphone-screen-helper';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  flex: 1;
  padding: 0 24px;
`;

export const FilterList = styled.View`

`;

export const FilterCard = styled.View`
  background-color: ${({theme}) => theme.colors.shape};
  border-radius: ${RFValue(16)}px;
  border: 1px solid ${({theme}) => theme.colors.border2};
  shadow-color: #000;
  shadow-opacity: 0.04;
  shadow-radius: 6px;
  shadow-offset: 0px 4px;
  elevation: 1;
  overflow: hidden;
`;

export const Filter = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  padding: 0 16px;
  justify-content: space-between;
  height: ${RFValue(50)}px;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border2};
`;

export const FilterText = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
`;

export const FilterInfo = styled.View`
  flex-direction: row;
  align-items: center;
  flex: 1;
`;

export const Icon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;

export const RemoveFilterButton = styled.TouchableOpacity``;
export const RemoveFilter = styled.Text``;

export const Footer = styled.View`
  padding: 0 24px;
  margin-top: ${RFValue(6)}px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
`;

export const FilterBadge = styled.View`
  padding: ${RFValue(3)}px ${RFValue(8)}px;
  background-color: ${({theme}) => theme.colors.primary};
  border-radius: ${RFValue(12)}px;
  margin-left: ${RFValue(6)}px;
`;

export const FilterBadgeText = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
`;

export const FilterRow = styled.View`
  flex-direction: row;
  align-items: center;
  flex: 1;
`;

export const FilterSubtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  margin-top: ${RFValue(12)}px;
`;
